<template>
  <v-lazy
    v-model="isActive"
    :options="{
      threshold: 0.5,
    }"
    transition="fade-transition"
  >
    <v-row align="center">
      <!-- user info -->
      <v-col cols="12" md="12">
        <v-card outlined min-height="280" height="auto" elevation="1">
          <v-menu offset-y transition="slide-y-transition" bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                absolute
                right
                top
                v-bind="attrs"
                v-on="on"
                class="mt-1 mr-3"
                outlined
                color="#1141ce"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list rounded subheader class="mb-0 pb-0">
              <v-list-item style="cursor: pointer" @click="edituser()">
                <v-list-item-title class="primary--text"
                  >Edit</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
          <Edituser :infos="infos" />
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce">mdi-account</v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.user.name") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row justify="center" align="center" class="pt-3" no-gutters>
              <v-col cols="12" sm="4">
                <v-row
                  align="center"
                  justify="center"
                  class="text-center"
                  dense
                >
                  <v-col cols="12" sm="12">
                    <span class="font-weight-medium">{{
                      $t("users.infos.user.firstname")
                    }}</span>
                    :
                    {{ infos.firstname ? infos.firstname : "-" }}
                  </v-col>
                  <v-col cols="12" sm="12">
                    <span class="font-weight-medium">{{
                      $t("users.infos.user.lastname")
                    }}</span>
                    :
                    {{ infos.lastname ? infos.lastname : "-" }}
                  </v-col>
                  <v-col cols="12" sm="12">
                    <span class="font-weight-medium">{{
                      $t("users.infos.user.id")
                    }}</span>
                    :
                    {{ infos.id ? infos.id : "-" }}
                  </v-col>
                  <v-col cols="12" sm="12">
                    <span class="font-weight-medium">{{
                      $t("users.infos.user.email")
                    }}</span>
                    :
                    {{ infos.email ? infos.email : "-" }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="4">
                <div class="separater"></div>
                <v-col cols="12" sm="12">
                  <v-row
                    align="center"
                    justify="center"
                    class="text-center"
                    dense
                  >
                    <v-col cols="12" sm="12">
                      <span class="font-weight-medium mr-4"
                        >{{ $t("users.infos.user.gender") }} :</span
                      >{{ infos.gender ? infos.gender : "-" }}
                    </v-col>
                    <v-col cols="12" sm="12">
                      <span class="font-weight-medium mr-4"
                        >{{ $t("users.infos.user.language") }} :</span
                      >{{ infos.language ? infos.language : "-" }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="separater"></div>
                <v-row
                  align="center"
                  justify="center"
                  class="text-center"
                  dense
                >
                  <v-col cols="12" sm="12" class="font-weight-medium">
                    <v-icon>mdi-map-marker-radius</v-icon>
                    {{ $t("users.infos.user.address") }} :
                  </v-col>
                  <v-col cols="12" sm="12" class="text-strat">
                    {{ infos.address ? infos.address : "-" }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row> </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!---------------------------------->

      <!-- activities info -->
      <v-col cols="12" md="12">
        <v-card outlined min-height="280" height="auto" elevation="1">
          <v-btn
            icon
            absolute
            right
            top
            class="mt-1 mr-3"
            outlined
            color="#1141ce"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce"> mdi-chart-bar </v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.activities.name") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-container>
          <StatusChart :infos="infos" />
        </v-card>
      </v-col>
      <!---------------------------------->

      <!-- size info -->
      <v-col cols="12" md="6">
        <v-card outlined min-height="280" height="auto" elevation="1">
          <v-btn
            icon
            absolute
            right
            top
            class="mt-1 mr-3"
            outlined
            color="#1141ce"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce">mdi-set-square</v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.size.name") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row justify="center" align="center" no-gutters>
              <v-col>
                <v-row justify="center" align="center">
                  <v-col>
                    <v-row class="text-center" align="center" dense>
                      <v-col
                        cols="12"
                        sm="12"
                        class="black--text font-weight-bold"
                      >
                        <v-chip class="ma-2" dark color="#363636">
                          {{ $t("users.infos.size.size_fr.name") }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.size_fr.tops") }} :
                        {{ infos.size_fr_top ? infos.size_fr_top : "-" }}
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.size_fr.pants") }} :
                        {{ infos.size_fr_pants ? infos.size_fr_pants : "-" }}
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.size_fr.shoes") }} :
                        {{ infos.size_fr_shoes ? infos.size_fr_shoes : "-" }}
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="text-center" dense>
                      <v-col
                        cols="12"
                        sm="12"
                        class="black--text font-weight-bold"
                      >
                        <v-chip class="ma-2" dark color="#363636">
                          {{ $t("users.infos.size.size_us.name") }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.size_us.tops") }} :
                        {{ infos.size_us_top ? infos.size_us_top : "-" }}
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.size_us.pants") }} :
                        {{ infos.size_us_pants ? infos.size_us_pants : "-" }}
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.size_us.shoes") }} :
                        {{ infos.size_us_shoes ? infos.size_us_shoes : "-" }}
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="text-center" dense>
                      <v-col
                        cols="12"
                        sm="12"
                        class="black--text font-weight-bold"
                      >
                        <v-chip class="ma-2" dark color="#363636">
                          {{ $t("users.infos.size.measurements.name") }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.measurements.chest") }} :
                        {{
                          infos.size_measurements_chest
                            ? infos.size_measurements_chest
                            : "-"
                        }}
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.measurements.waist") }} :
                        {{
                          infos.size_measurements_waist
                            ? infos.size_measurements_waist
                            : "-"
                        }}
                      </v-col>
                      <v-col cols="12" sm="12" class="font-weight-medium">
                        {{ $t("users.infos.size.measurements.hips") }} :
                        {{
                          infos.size_measurements_hips
                            ? infos.size_measurements_hips
                            : "-"
                        }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!---------------------------------->

      <!-- Preferences info -->
      <v-col cols="12" md="6">
        <v-card outlined min-height="280" height="auto" elevation="1">
          <v-btn
            icon
            absolute
            right
            top
            class="mt-1 mr-3"
            outlined
            color="#1141ce"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce"> mdi-cog </v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.preferences.name") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row justify="center" dense>
              <v-col>
                <v-row class="text-center" dense>
                  <v-col cols="12" sm="12" class="font-weight-bold">
                    <v-chip class="ma-2 mt-4" dark color="#363636">
                      {{ $t("users.infos.preferences.styles") }} :
                    </v-chip>
                  </v-col>
                  <v-col
                    v-show="infos.styles"
                    v-for="(style, idx) in infos.styles"
                    :key="idx"
                    cols="12"
                    sm="12"
                    class="font-weight-medium"
                  >
                    {{ style }}
                  </v-col>
                  <v-col
                    v-show="!infos.styles"
                    cols="12"
                    sm="12"
                    class="font-weight-medium"
                  >
                    -
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="text-center" dense>
                  <v-col cols="12" sm="12" class="font-weight-bold">
                    <v-chip class="ma-2 mt-4" dark color="#363636">
                      {{ $t("users.infos.preferences.occasions") }} :
                    </v-chip>
                  </v-col>
                  <v-col
                    v-show="infos.occasions"
                    v-for="(occasion, idx) in infos.occasions"
                    :key="idx"
                    cols="12"
                    sm="12"
                    class="font-weight-medium"
                  >
                    {{ occasion }}
                  </v-col>
                  <v-col
                    v-show="!infos.occasions"
                    cols="12"
                    sm="12"
                    class="font-weight-medium"
                  >
                    -
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row class="text-center" dense>
                  <v-col cols="12" sm="12" class="font-weight-bold">
                    <v-chip class="ma-2 mt-4" dark color="#363636">
                      {{ $t("users.infos.preferences.materials") }} :
                    </v-chip>
                  </v-col>
                  <v-col
                    v-show="infos.materials"
                    v-for="(material, idx) in infos.materials"
                    :key="idx"
                    cols="12"
                    sm="12"
                    class="font-weight-medium"
                  >
                    {{ material }}
                  </v-col>
                  <v-col
                    v-show="!infos.materials"
                    cols="12"
                    sm="12"
                    class="font-weight-medium"
                  >
                    -
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!---------------------------------->

      <!-- last search  info -->
      <v-col cols="12" md="12">
        <v-card outlined min-height="300" height="auto" elevation="1">
          <v-btn
            icon
            absolute
            right
            top
            class="mt-1 mr-3"
            outlined
            color="#1141ce"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce">mdi-search-web</v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.last_search") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center" justify="center" desnse>
              <v-col>
                <v-row class="pl-5" dense>
                  <v-col cols="12" sm="6" class="font-weight-medium">
                    1. Article 1 ..........
                  </v-col>

                  <v-col cols="12" sm="6" class="font-weight-medium">
                    2. Article 2 ..........
                  </v-col>

                  <v-col cols="12" sm="6" class="font-weight-medium">
                    2. Article 3 ...........
                  </v-col>
                  <v-col cols="12" sm="6" class="font-weight-medium">
                    4. Article 4 ..........
                  </v-col>

                  <v-col cols="12" sm="6" class="font-weight-medium">
                    5. Article 5 ..........
                  </v-col>

                  <v-col cols="12" sm="6" class="font-weight-medium">
                    6. Article 6 ..........
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!--------------------------------->

      <!-- Top liked features info -->
      <v-col cols="12" md="6">
        <v-card outlined min-height="300" height="auto" elevation="1">
          <v-btn
            icon
            absolute
            right
            top
            class="mt-1 mr-3"
            outlined
            color="#1141ce"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce">mdi-thumb-up</v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.top_like") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center" justify="center">
              <v-col v-if="infos.products_liked && infos.products_liked.length">
                <v-row ajustify="space-around" class="pl-5" dense>
                  <v-col
                    v-show="
                      infos.products_liked.length && idx < 10 && products[prod]
                    "
                    v-for="(prod, idx) in infos.products_liked"
                    :key="idx"
                    cols="12"
                    sm="6"
                    class="font-weight-medium"
                  >
                    {{
                      `${idx + 1}. ${
                        products[prod] ? products[prod].name : "-"
                      }`
                    }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-else
                cols="12"
                sm="12"
                class="text-center font-weight-medium mt-12 pt-6"
              >
                <v-icon>mdi-text-box-remove </v-icon> no liked products...
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!--------------------------------->

      <!-- Top Dislike features info -->
      <v-col cols="12" md="6">
        <v-card outlined min-height="300" height="auto" elevation="1">
          <v-btn
            icon
            absolute
            right
            top
            class="mt-1 mr-3"
            outlined
            color="#1141ce"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce">mdi-thumb-down</v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1">
                  {{ $t("users.infos.top_dislike") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center" justify="center">
              <v-col
                v-if="
                  infos.products_disliked_set &&
                  infos.products_disliked_set.length
                "
              >
                <v-row ajustify="space-around" class="pl-5" dense>
                  <v-col
                    v-for="(prod, idx) in infos.products_disliked_set"
                    :key="idx"
                    cols="12"
                    sm="6"
                    class="font-weight-medium"
                    v-show="
                      infos.products_disliked_set.length &&
                      idx < 10 &&
                      products[prod]
                    "
                  >
                    {{
                      `${idx + 1}. ${
                        products[prod] ? products[prod].name : "-"
                      }`
                    }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-else
                cols="12"
                sm="12"
                class="text-center font-weight-medium mt-12 pt-6"
              >
                <v-icon>mdi-text-box-remove </v-icon> no disliked products...
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!---------------------------------->
      <!-- Specific comments info -->
      <v-col cols="12" md="12">
        <v-card outlined min-height="300" height="auto" elevation="1">
          <v-btn
            icon
            absolute
            right
            top
            class="mt-1 mr-3"
            outlined
            color="#1141ce"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
          <v-container class="pt-2">
            <v-row>
              <v-col cols="auto">
                <v-icon size="35" color="#1141ce">mdi-comment-text</v-icon>
              </v-col>
              <v-col cols="auto">
                <h1 class="headline font-weight-medium pt-1 text-truncate">
                  {{ $t("users.infos.specific_comment.name") }}
                </h1>
                <v-lazy
                  v-model="isActive"
                  :options="{
                    rootMargin: '0px',
                    threshold: 1.0,
                  }"
                  transition="slide-x-transition"
                >
                  <div class="line"></div>
                </v-lazy>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="11">
                <v-container>
                  <v-textarea
                    clearable
                    outlined
                    rows="4"
                    clear-icon="mdi-close-circle "
                    :label="$t('users.infos.specific_comment.label')"
                    :value="$t('users.infos.specific_comment.placeholder')"
                  ></v-textarea>
                  <v-btn class="ok-btn" color="grey darken-3" dark>
                    <b>ok</b>
                  </v-btn>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <!---------------------------------->
    </v-row>
  </v-lazy>
</template>

<script>
import StatusChart from "./graph_status_info";
import Edituser from "./Edit_user";

export default {
  data() {
    return {
      model: 0,
      isActive: 0,
      edit: false,
    };
  },
  props: {
    infos: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    products: {
      get: function () {
        const prod = this.$store.state.product.products;
        return prod;
      },
    },
  },
  components: {
    StatusChart,
    Edituser,
  },
  methods: {
    edituser() {
      this.$store.state.show.edit_user = true;
    },
  },
};
</script>

<style scoped>
.title-card {
  color: #1141ce;
}
.card-footer {
  position: absolute;
  bottom: 2%;
  width: 100%;
}
.card-footer-line {
  border-top: solid 1px #e0e0e0;
  position: absolute;
  width: 96%;
  bottom: 12%;
  margin: 2px;
}
.carsul-btn {
  max-width: 100%;
}
@media only screen and (min-width: 500px) {
  .separater {
    border: 0.5px solid #a4a4a4;
    height: 50%;
    width: 1px;
    position: absolute;
    bottom: 18%;
    margin: -12px;
  }
}
@media only screen and (max-width: 500px) {
  .card-footer {
    display: none;
  }
  .card-footer-line {
    display: none;
  }
  .ok-btn {
    position: absolute;
    right: 40% !important;
    top: 78%;
    width: 7%;
  }
}
.line {
  display: block;
  position: relative;
  margin: 0 auto;
  height: 3px;
  background: rgb(0, 212, 255);
  background: linear-gradient(
    49deg,
    rgba(0, 212, 255, 1) 0%,
    rgba(2, 0, 36, 1) 0%,
    rgba(17, 65, 206, 1) 41%
  );
  width: 81%;
  left: 36%;
  top: 2px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-49%);
}
.ok-btn {
  position: absolute;
  right: 47%;
  top: 78%;
  width: 7%;
}
</style>
